"use client";

import React, { useRef } from "react";
import { ArrowUpRight, ChevronLeft, ChevronRight } from "lucide-react";
import { motion, useReducedMotion } from "framer-motion";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
const youthCards = [{
  id: 1,
  title: "MINISTERIOS NACIONAL A LOS JÓVENES",
  description: "Interactuamos e inspiramos a los jóvenes para que crezcan en su fe y descubran el propósito que tienen en Dios a través de programas y eventos dinámicos.",
  imageSrc: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1768199/img/youth_ministry_worship.png",
  imageSrcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1768199/img/youth_ministry_worship.png-wvc-srcset",
  imageSizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1768199/img/youth_ministry_worship.png-wvc-sizes",
  altText: "Jóvenes en concierto de adoración y alabanza",
  linkUrl: "#"
}, {
  id: 2,
  title: "BELLAS ARTES",
  description: "Cultivamos la creatividad y la expresión artística entre los jóvenes a la vez que creamos adoración y desarrollo espiritual.",
  imageSrc: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1768199/img/youth_fine_arts.webp",
  imageSrcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1768199/img/youth_fine_arts.webp-wvc-srcset",
  imageSizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1768199/img/youth_fine_arts.webp-wvc-sizes",
  altText: "Joven con pintura y expresión artística",
  linkUrl: "#"
}, {
  id: 3,
  title: "SPEED THE LIGHT",
  description: "Empoderamos a los jóvenes para que apoyen las misiones globales al recaudar fondos para necesidades ministeriales vitales.",
  imageSrc: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1768199/img/youth_speed_the_light.png",
  imageSrcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1768199/img/youth_speed_the_light.png-wvc-srcset",
  imageSizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1768199/img/youth_speed_the_light.png-wvc-sizes",
  altText: "Grupo de jóvenes y niños en viaje misionero",
  linkUrl: "#"
}, {
  id: 4,
  title: "BIBLE QUIZ",
  description: "Desafiamos a los adolescentes a profundizar su conocimiento de la Biblia y desarrollar sus habilidades de pensamiento crítico a través de competencias amistosas.",
  imageSrc: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1768199/img/youth_bible_quiz.png",
  imageSrcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1768199/img/youth_bible_quiz.png-wvc-srcset",
  imageSizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1768199/img/youth_bible_quiz.png-wvc-sizes",
  altText: "Joven sosteniendo la Biblia al aire libre",
  linkUrl: "#"
}];
export default function Youth() {
  const scrollContainerRef = useRef<HTMLDivElement>(null);
  const shouldReduceMotion = useReducedMotion();
  const handleScroll = (direction: "left" | "right") => {
    if (!scrollContainerRef.current) return;
    const {
      scrollLeft,
      clientWidth
    } = scrollContainerRef.current;
    const scrollAmount = clientWidth * 0.75;
    scrollContainerRef.current.scrollTo({
      left: direction === "left" ? scrollLeft - scrollAmount : scrollLeft + scrollAmount,
      behavior: "smooth"
    });
  };
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    show: {
      opacity: 1,
      transition: {
        staggerChildren: shouldReduceMotion ? 0 : 0.12
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: shouldReduceMotion ? 0 : 20
    },
    show: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5,
        ease: "easeOut"
      }
    }
  };
  return <section id="youthministriesgrid" data-nav="light" className="relative w-full bg-muted/20 py-12 md:py-16 lg:py-20">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="relative">
          {}
          <div className="pointer-events-none absolute inset-y-0 -left-3 -right-3 z-20 flex items-center justify-between xl:hidden">
            <Button type="button" variant="default" size="icon" onClick={() => handleScroll("left")} aria-label="Anterior" className="pointer-events-auto size-9 rounded-full bg-foreground/80 text-background shadow-md backdrop-blur-sm transition-colors hover:bg-foreground">
              <ChevronLeft className="size-5" />
            </Button>
            <Button type="button" variant="default" size="icon" onClick={() => handleScroll("right")} aria-label="Siguiente" className="pointer-events-auto size-9 rounded-full bg-foreground/80 text-background shadow-md backdrop-blur-sm transition-colors hover:bg-foreground">
              <ChevronRight className="size-5" />
            </Button>
          </div>

          {}
          <motion.div ref={scrollContainerRef} variants={containerVariants} initial="hidden" whileInView="show" viewport={{
          once: true,
          amount: 0.15
        }} className="flex snap-x snap-mandatory gap-5 overflow-x-auto pb-4 pt-2 scrollbar-none sm:gap-6 lg:grid lg:grid-cols-4 lg:gap-6 lg:overflow-visible lg:pb-0">
            {youthCards.map((card, i) => <motion.article key={card.id} data-index={i} variants={itemVariants} className="group relative flex h-[480px] w-[280px] shrink-0 snap-start flex-col justify-end overflow-hidden rounded-2xl bg-card shadow-md transition-shadow hover:shadow-xl sm:w-[320px] lg:h-[500px] lg:w-full">
                {}
                <div className="absolute inset-0 z-0">
                  <img src={card.imageSrc} data-wvc-srcset={card.imageSrcset} data-wvc-sizes={card.imageSizes} alt={card.altText} loading="lazy" decoding="async" className="size-full object-cover transition-transform duration-700 ease-out group-hover:scale-105" />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-black/20" />
                </div>

                {}
                <Link to={card.linkUrl} aria-label={`Ver más de ${card.title}`} className="absolute right-4 top-4 z-10 flex size-9 items-center justify-center rounded-full bg-background/90 text-foreground shadow-sm transition-colors hover:bg-primary hover:text-primary-foreground focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-ring">
                  <ArrowUpRight className="size-4.5" />
                </Link>

                {}
                <div className="relative z-10 m-3 flex flex-col justify-between rounded-xl border-b-4 border-primary bg-background p-5 shadow-sm sm:m-4 sm:p-5">
                  <div>
                    <h3 className="text-base font-bold tracking-tight text-foreground sm:text-lg">
                      {card.title}
                    </h3>
                    <p className="mt-2 text-xs leading-relaxed text-muted-foreground sm:text-sm">
                      {card.description}
                    </p>
                  </div>

                  <div className="mt-4 pt-1">
                    <Button asChild variant="default" size="sm" className="group/btn h-8 rounded-full bg-foreground px-4 text-xs font-semibold text-background transition-colors hover:bg-foreground/90">
                      <Link to={card.linkUrl} className="inline-flex items-center gap-1.5">
                        <span>MÁS INFORMACIÓN</span>
                        <ArrowUpRight className="size-3.5 transition-transform group-hover/btn:translate-x-0.5 group-hover/btn:-translate-y-0.5" />
                      </Link>
                    </Button>
                  </div>
                </div>
              </motion.article>)}
          </motion.div>
        </div>
      </div>
    </section>;
}